import Component from './component'
import EnhanceRedirectToFirstProjectTasks from './enhancers/EnhanceRedirectToFirstProjectTasks'

export default EnhanceRedirectToFirstProjectTasks(Component)
